/**
 * CSS produk My Apps yang di-inline ke IIFE (`mjl-my-apps.min.js`).
 *
 * Urutan layer sama dengan host ui-kit (token → Tailwind → komponen SCSS),
 * lalu custom.scss untuk aturan yang tidak ada di design system.
 * Host (Hub/ERP/MIS) tidak load file CSS terpisah.
 */
import { joinCss } from '@mjl/shared';
import tokens from '@mjl/ui-kit/styles?inline';
import tailwind from './widget-tailwind.css?inline';
import post from '@mjl/ui-kit/styles/post-tailwind?inline';
import custom from './custom.scss?inline';

/** String CSS siap pakai untuk `attachUiKitShadow` (Shadow Root). */
export const widgetCss = joinCss(tokens, tailwind, post, custom);
